import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextSemiBold } from 'UiKit/typography';

import { useRequestApprovalState } from 'View/reschedule/state';
import scrollTableToLeft from 'Helper/scrollTableToLeft';

import styles from './styles.module.css';

const Tab = () => {
  const { t } = useTranslation('reschedule');
  const { state, updateState, resetFilterState } = useRequestApprovalState();

  const updateSelectedTab = (selectedTab) => {
    scrollTableToLeft();
    updateState({ selectedTab });
    resetFilterState();
  };

  return (
    <Flex className={styles['tab__container']}>
      <Flex className={styles['tab__container--left']}>
        <Box
          className={`${styles['tab__item']} ${state?.selectedTab === 'requested' && styles['tab__item--actived']}`}
          onClick={() => updateSelectedTab('requested')}
        >
          <TextSemiBold className={styles['tab__text']}>{t('tabRequested')}</TextSemiBold>
        </Box>

        <Box className={`${styles['tab__item']} ${state?.selectedTab === 'done' && styles['tab__item--actived']}`} onClick={() => updateSelectedTab('done')}>
          <TextSemiBold className={styles['tab__text']}>{t('tabDone')}</TextSemiBold>
        </Box>
      </Flex>
    </Flex>
  );
};

export default Tab;
